"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuthStore } from "@/modules/auth/stores/useAuthStore";
import { useAuthFormFields } from "../hooks/useBootstrap";

/**
 * Loja fechada (login_form_fields.requireLogin): quando a sessão acaba — logout
 * ou refresh que falhou de vez — o BFF já apagou os cookies, e o refresh do
 * router faz o root layout re-decidir no servidor e trocar a vitrine pelo
 * LoginGate.
 *
 * Só a TRANSIÇÃO authenticated → unauthenticated conta: o status inicial vem
 * do cookie auth_user, que pode discordar do cookie de refresh que o SSR lê —
 * reagir a ele faria loop de refresh.
 */
export function LoginGateInit() {
    const requireLogin = useAuthFormFields().login.requireLogin;
    const router = useRouter();

    useEffect(() => {
        if (!requireLogin) return;
        return useAuthStore.subscribe((state, previous) => {
            if (previous.status === "authenticated" && state.status === "unauthenticated") {
                router.refresh();
            }
        });
    }, [requireLogin, router]);

    return null;
}
